<template>
  <div class="pc index___en">
    <!-- header -->
    <head-top></head-top>
    <div class="n-config-provider" style="height: auto !important;">
      <div class="page isPc genres-page page" style="min-height: calc(-80px + 100vh);">
        <!-- 主界面 -->
        <router-view></router-view>

        <!-- 页脚 -->
        <FooterVue></FooterVue>
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/base/head.vue'
import FooterVue from "@/components/base/footer.vue"
export default {
  name: 'IndexVue',
  components: {
    HeadTop,
    FooterVue,
  },

  watch: {
    router(a, b) {
      console.log(a, b)
    }
  }
}
</script>

<style scoped></style>
